import $ from 'jquery';
import moment from 'moment/moment';
import View from 'mixins/view';
import CommentContentTextView from '@ui/comments/comment-content-text-view';
import { CommentSocioView } from '@ui/comments/comment-socio-view';
import { siteModel } from 'models/SiteModel';

export const elements = {
    mainContent: '.comment-text',
};

export default class HomeCommentView extends View {
    constructor(model) {
        super(model);
        this.setRootEl($('<article class="user-comment"></article>'));
    }
    initLinkAction() {
        this.rootEl
            .find('.user-comment__source a')
            .on('click', function (event) {
                event.stopPropagation();
                event.preventDefault();
                window.location.replace($(this).attr('href'));
            });
    }
    render() {
        const model = this.model;
        const author = model.get('User');

        const createdAt = moment(model.get('createdAt')).format('DD.MM.YYYY HH:mm:ss');
        const User = siteModel.get('User');

        this.rootEl.html(`
            <div class="c-comments__box">
                <figure class="c-comments__avatar">
                    <img src="${author.get('thumbnail')}" alt="avatar">
                </figure>
                <div class="c-comments__content">
                    <div class="cc-content user-comment__text">
                        <div class="uct-comment-header rmpl-flex-container rmpl-flex-aligned rmpl-flex-nowrap">
                            <strong class="user-comment__name">
                                ${author.get('displayName')}
                            </strong>
                            <time class="rmpl-flex-item-auto" datetime="${model.get('createdAt')}">
                                ${createdAt}
                            </time>
                            <span class="rmpl-flex-item-auto"> pod artykułem </span>
                        </div>
                        <div class="rmpl-flex-container rmpl-flex-aligned shift-margin_1-bottom">
                            <span class="user-comment__source">
                                <strong>
                                    <a href="${model.get('articleUrl')}">${model.get('articleTitle')}</a>
                                </strong>
                            </span>
                        </div>
                        <aside class="rmpl-flex-container rmpl-flex-aligned c-comments__action">
                            <span class="rmpl-flex-item-auto c-comments__recommend-container box-inline shift-margin_1-left">
                                <i class="icon-size_2-star-color_apporange"></i>
                            </span>
                            <span class="rmpl-flex-item-auto c-comments__rating-container box-inline">
                                <strong class="text-color_lightgrey">${model.get('likesCount')}</strong>
                                <i class="icon-size_2-like-color_${model.get('isLikedByUser') ? 'apporange' : 'lightgrey'}"></i>
                            </span>
                        </aside>
                    </div>
                </div>
            </div>
        `);

        /*
         * Visible only for moderators and other users who dont see moderator labels
         */
        if (User.isModerator() || !author.isModerator()) {
            const commentSocioView = new CommentSocioView(model);
            commentSocioView.render();
            this.rootEl.find('.user-comment__name').after(commentSocioView.getRootEl());
        }

        /**
         * Render content of comment with expanding button
         */
        const commentContentTextView = new CommentContentTextView(model);
        commentContentTextView.render();
        this.rootEl
            .find('.cc-content')
            .append(commentContentTextView.getRootEl());

        /**
         * Comment click handler - check out if target is expanding comment button
         */
        this.rootEl.find(elements.mainContent).on('click', (event) => {
            event.preventDefault();
            const target = $(event.target);

            if (target.is('.ct-show-more')) {
                return false;
            }
            window.location.replace(model.get('commentUrl'));
            return true;
        });
        this.initLinkAction();
    }
}



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/comments/home/comment-view.js